export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-smile-2-line text-base text-background-50"></i>
              </span>
              <span className="text-lg font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>吃瓜群</span>
            </div>
            <p className="text-xs leading-relaxed text-foreground-400">
              吃瓜群汇聚全网最新娱乐八卦与热点事件，为吃瓜群众提供免费、及时、全面的吃瓜内容。无需注册，打开即看，全天候持续更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>快速导航</h4>
            <div className="space-y-2">
              <a href="#ranking" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">吃瓜热度榜</a>
              <a href="#index" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">吃瓜索引</a>
              <a href="#updates" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">实时快讯</a>
              <a href="#topics" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
              <a href="#cards" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">最新瓜条</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>关于我们</h4>
            <div className="space-y-2">
              <a href="#about" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于吃瓜群</a>
              <a href="#faq" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
              <a href="#contact" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">投稿爆料</a>
              <a href="#comments" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">瓜友热评</a>
              <a href="#features" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">平台特色</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 吃瓜群 - 吃瓜群众免费吃瓜平台。本站内容仅供娱乐参考，请理性吃瓜。
          </p>
          <p className="text-xs text-foreground-600">
            吃瓜群众免费吃瓜 · 吃瓜群众是什么意思 · 在线吃瓜
          </p>
        </div>
      </div>
    </footer>
  );
}